import type { RootState } from "@/store/app/storeTypes";
import type { SparxsBlueprintCacheState } from "@/store/sparxsCatalog/blueprintCacheSlice";

export const selectSparxsBlueprintCachePersistRehydrated = (
  state: RootState,
): boolean => {
  const p = (
    state.editor.sparxsBlueprintCache as SparxsBlueprintCacheState & {
      _persist?: { rehydrated?: boolean };
    }
  )._persist;
  return p == null || p.rehydrated === true;
};
